import { BaseModel } from '@/models/baseModel'
import { UserModel } from '@/models/user'
import { ProspectModel } from '@/models/prospect'

export class ForumResponseMentionModel extends BaseModel {
  constructor(mentionData) {
    super()

    const { mentionId, fullName, userId, prospectId, isReply, isAnonymous, toModerator, anonymousId } =
      mentionData || {}

    this.mentionId = mentionId || null
    this.fullName = fullName || null
    this.userId = userId || null
    this.prospectId = prospectId || null
    this.isReply = isReply || false

    this.isAnonymous = isAnonymous || false
    this.toModerator = toModerator || false

    this.anonymousId = anonymousId || null
  }

  static parseFromApi({ mention, user: apiUser, prospect: apiProspect }) {
    const user = apiUser ? UserModel.parseFromApi({ user: apiUser }) : null
    const prospect = apiProspect ? ProspectModel.parseFromApi({ prospect: apiProspect }) : null

    let fullName = mention.fullName
    if (user) {
      fullName = user.fullNameWithShortLastName
    } else if (prospect) {
      fullName = prospect.fullNameWithShortLastName
    }

    return new ForumResponseMentionModel({
      mentionId: mention.id,
      fullName,
      userId: mention.userId,
      prospectId: mention.prospectId,
      isReply: mention.isReply,
      isAnonymous: mention.isAnonymous,
      toModerator: mention.toModerator,
      anonymousId: mention.anonymousId
    })
  }

  convertToApi() {
    return {
      id: this.mentionId,
      fullName: this.fullName || undefined,
      userId: this.userId || undefined,
      prospectId: this.prospectId || undefined,
      isReply: this.isReply ?? undefined,
      isAnonymous: this.isAnonymous ?? undefined,
      toModerator: this.toModerator ?? undefined,
      anonymousId: this.anonymousId || undefined
    }
  }
}
